module.exports = __webpack_public_path__ + "img/other-bg-op.88affa16.png";